import { render } from "./ViewBotNav.vue?vue&type=template&id=21ead5f4"
import script from "./ViewBotNav.vue?vue&type=script&lang=js"
export * from "./ViewBotNav.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\pa-health-connect\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__